import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'
import PreviewBusDetail from '@/components/my-booking/modals/PreviewBusDetail'
import { getBookingTransportationQueryOptions } from '@/queries/query'
import { BaseRedirectSearchSchema } from '@/schemas/page'

export const Route = createFileRoute(
  '/my-booking/$id/view/$transportationId/detail',
)({
  validateSearch: BaseRedirectSearchSchema.partial({ redirect: true }),
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const navigate = Route.useNavigate()
  const redirect = Route.useSearch({
    select: (s) => s.redirect,
  })
  const transportationId = Route.useParams({
    select: (s) => s.transportationId,
  })

  const {
    data: {
      data: { booked_transportation },
    },
  } = useSuspenseQuery(getBookingTransportationQueryOptions(transportationId))

  const onClose = useCallback(() => {
    if (redirect) {
      navigate({
        href: redirect,
        replace: true,
        resetScroll: false,
        ignoreBlocker: true,
      })
      return
    }
    if (router.history.canGoBack()) {
      return router.history.back()
    }
    navigate({
      to: '/my-booking/$id/view',
      params: {
        id: booked_transportation.adhoc_booking_id,
      },
    })
  }, [redirect, router.history, booked_transportation.adhoc_booking_id])

  return (
    <PreviewBusDetail isOpen bus={booked_transportation} onClose={onClose} />
  )
}
